"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.977 11.829h-1V4.173h1v7.656Zm-2.473-.631h1V4.844h-1v6.354Zm2.914-2.719h7.164v-1H4.418v1ZM1 10.782H0v-5.23h1v5.23Zm14 0h1v-5.23h-1v5.23Zm-2.873 1.047h1V4.173h-1v7.656Zm2.484-.647h-1V4.828h1v6.354Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.665 17.639H4.54V6.362h1.125V17.64Zm-3.371-.963h1.125v-9.29H2.294v9.29Zm4.243-4.146h10.925v-1.125H6.537v1.125Zm-5.412 3.513H0V8.466h1.125v7.575Zm21.75 0H24V8.466h-1.125v7.575Zm-4.382 1.596h1.125V6.362h-1.125V17.64Zm3.39-.986h-1.126v-9.29h1.125v9.29Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.553 23.518h-1.5V8.483h1.5v15.035Zm-4.495-1.283h1.5V9.848h-1.5v12.387Zm5.658-5.528h14.567v-1.5H8.716v1.5ZM1.5 21.39H0V11.289h1.5V21.39Zm29 0H32V11.289h-1.5V21.39Zm-5.843 2.128h1.5V8.483h-1.5v15.035Zm4.519-1.314h-1.5V9.817h1.5v12.387Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.028 35.172H9.153V12.828h1.875v22.344Zm-6.403-1.94H6.5V14.895H4.625v18.339Zm8.36-8.36h22.03v-1.875h-22.03v1.875Zm-11.11 7.082H0V17.072h1.875v14.883Zm44.25 0H48V17.072h-1.875v14.883Zm-8.836 3.218h1.875V12.828H37.29v22.344Zm6.44-1.986h-1.874V14.847h1.875v18.339Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.704 46.896h-2.5V17.104h2.5v29.792ZM6.167 44.31h2.5V19.858h-2.5V44.31Zm11.147-11.148h29.373v-2.5H17.316v2.5ZM2.5 42.606H0V22.763h2.5v19.843Zm59 0H64V22.763h-2.5v19.843Zm-11.781 4.29h2.5V17.104h-2.5v29.792Zm8.587-2.648h-2.5V19.796h2.5v24.452Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconStrength = function IconStrength(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Strength' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Strength"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconStrength.sizes = [16, 24, 32, 48, 64];
IconStrength.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconStrength;
exports.default = _default;